import get from "lodash/get";

import {
  getFile,
  getIdAndMultiName,
  getMultiName,
  getServicePoint,
} from "helpers/mappers";

export const ServiceRegister = (item) => ({
  id: get(item, "id") || "",
  uniqueNumber: get(item, "service_number") || "",
  serviceName: getMultiName(get(item, "service_name")),
  organization: getIdAndMultiName(get(item, "organization")),
  addition: (get(item, "addition") || []).map((value) => getMultiName(value)),
  organizations: (get(item, "organizations") || []).map((value) =>
    getIdAndMultiName(value),
  ),
  usersType: get(item, "users_type") || "",
  subjectType: get(item, "subject_type") || "",
  serviceType: get(item, "service_type") || "",
  serviceForm: get(item, "service_form") || "",
  servicePoint: get(item, "service_point") || "",
  documents: get(item, "documents") || [],
  paymentType: get(item, "payment_type") || "",
  serviceResult: get(item, "service_result") || "",
  withPayment: get(item, "payment_info") || [],
  serviceDocument: get(item, "service_document") || "",
  principles: get(item, "principles_list") || [],
  requirements: get(item, "requirements") || [],
  description: get(item, "description", "") || "",
  servicePoints: (get(item, "service_points") || []).map((value) =>
    getServicePoint(value),
  ),
  validityPeriod: {
    id: get(item, "validity_period.id") || "",
    status: get(item, "validity_period.status") || "",
    type: get(item, "validity_period.type") || "",
    value: get(item, "validity_period.value") || "",
  },
  payments: (get(item, "payments") || []).map((value) => ({
    id: get(value, "id") || "",
    value: get(value, "payment_value") || 0,
    percent: get(value, "percent") || 0,
    name: get(value, "name") || "",
    type: get(value, "type") || "",
    description: get(value, "description") || "",
    accelerated: get(value, "accelerated") || false,
  })),
  expire: (get(item, "expire_periods") || []).map((value) => ({
    id: get(value, "id", ""),
    status: get(value, "status", ""),
    type: get(value, "type", ""),
    value: get(value, "value", ""),
    accelerated: get(value, "accelerated", false),
    description: get(value, "description", ""),
  })),
  compositeServices: get(item, "composite_services", []).map((value) => ({
    id: get(value, "id", ""),
    name: getMultiName(get(value, "name")),
  })),
  services: get(item, "services", []).map((value) => ({
    id: get(value, "id", ""),
    name: getMultiName(get(value, "name")),
  })),
  lifeSituations: get(item, "life_situations", []).map((value) => ({
    id: get(value, "id", ""),
    name: getMultiName(get(value, "name", "")),
    description: getMultiName(get(value, "description", "")),
  })),
  documentTypeIds: get(item, "document_type_ids", []).map((value) => ({
    id: get(get(value, "document_type", ""), "id", ""),
    name: getMultiName(get(get(value, "document_type", ""), "name", "")),
  })),
  documentTypeDescription: get(item, "document_type_description", "") || "",
  serviceSteps: get(item, "service_steps", []).map((value) => ({
    id: get(value, "id", ""),
    name: getMultiName(get(value, "name", "")),
    description: getMultiName(get(value, "description", "")),
  })),
});

export const OrganizationList = (item) => ({
  id: get(item, "id") || "",
  name: getMultiName(get(item, "name")) || "",
  count: get(item, "count") || 0,
  file_response: getFile(get(item, "file_response")),
});

export const ServiceSphere = (item) => ({
  id: get(item, "id") || "",
  name: getMultiName(get(item, "name")) || "",
  description: get(item, "description"),
});
